import axios from 'axios'
import { MutationCache, QueryClient } from 'react-query'
import { handleMutationError } from 'src/api/mutationErrorHandler'
import { isAppEnv, APP_ENV } from 'src/utils/env'

function getBaseURL() {
    const subdomain = isAppEnv('production') ? '' : `.${APP_ENV}`
    return `https://api${subdomain}.voiapp.io/`
}

export const ins = axios.create({ baseURL: getBaseURL(), adapter: 'fetch' })

export const queryClient = new QueryClient({
    mutationCache: new MutationCache({ onError: handleMutationError }),
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
})
